/** 订单中心 */ 
export default {
    name: 'order',
    path: 'order',
    meta: {
        title: '订单中心'
    },
    component: () => import('@/pages/index.vue'),
    children: [
        {
            name: 'order-center-application',
            path: '/admin/order-center/application',
            meta: { title: '应用订单' },
            component: () => import('@/pages/orderCenter/application.vue')
        },
        {
            name: 'order-center-package',
            path: '/admin/order-center/package',
            meta: { title: '版本订单' },
            component: () => import('@/pages/orderCenter/package.vue')
        }
    ]
}


